import api from './api';

const reviewService = {
  getReviews: async (params = {}) => {
    const response = await api.get('/admin/reviews', { params });
    return response.data.data;
  },

  deleteReview: async (id) => {
    const response = await api.delete(`/admin/reviews/${id}`);
    return response.data.data;
  },
};

export default reviewService;
